import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.parse-int.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Vue from 'vue';
import atom from '@tencent/vft-atom';
Vue.mixin({
  methods: {
    downloadKidAppInAndroid: function downloadKidAppInAndroid() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return atom.invoke('download3rdApp', {
                  packageName: 'com.tencent.qqlivekid',
                  downloadUrl: ' http://kid.v.qq.com/download?c=2114',
                  iconUrl: 'http://puui.qpic.cn/tv/0/32547804/0',
                  appName: '小企鹅乐园',
                  reportKey: 'magic-kid'
                }).then(function (res) {
                  return console.log(res);
                });

              case 3:
                _context.next = 5;
                return atom.invoke('register3rdAppDownloadListener');

              case 5:
                _context.next = 12;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);
                _this.$store.state.isDownloading = false;

                _this.$store.dispatch('getAppInstall');

              case 12:
                atom.on('onDownloadTaskProgressChanged', function (res) {
                  _this.$store.state.downloadPercent = res.progress <= 100 ? Number.parseInt(res.progress, 10) : 100;

                  if (_this.progress >= 100 || _this.progress === 0) {
                    _this.$store.state.isDownloading = false;

                    _this.$store.dispatch('getAppInstall');
                  } else {
                    _this.$store.state.isDownloading = true;
                    _this.installed = false;
                  }
                });
                atom.on('onDownloadTaskStateChanged', function (res) {
                  switch (res === null || res === void 0 ? void 0 : res.state) {
                    case 13:
                      _this.$store.state.isDownloading = true;
                      break;

                    case 10:
                      _this.$store.state.isDownloading = false;

                      _this.$store.dispatch('getAppInstall');

                      break;

                    case 11:
                      _this.$store.state.isDownloading = false;
                      _this.$store.state.downloadPercent = 0;
                      break;

                    default:
                  }
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    }
  }
});